import React from 'react';
import { Navigate } from 'react-router-dom';

export default function AI() {
  // Redirect to the new teacher chat page
  return <Navigate to="/teacher-chat" replace />;
}